import { Chart } from "../../../../src/components/chart";
import FAQ from "../../../../src/components/faq.mdx";
import * as React from 'react';
export default {
  Chart,
  FAQ,
  React
};